<script setup lang="ts">
import { TabsList, type TabsListProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<TabsListProps & { class?: string }>();
</script>

<template>
    <TabsList
        v-bind="props"
        :class="
            cn(
                'h-10 rounded-md bg-stone-100 p-1 text-stone-500 dark:bg-stone-800 dark:text-stone-400 inline-flex items-center justify-center',
                props.class,
            )
        "
    >
        <slot />
    </TabsList>
</template>
